export default __webpack_public_path__ + "static/media/centerImg1.1b35c621.png";